import * as z from "zod";

// Shared shapes for the Disputely §8.1 onboarding-autofill payload, imported by both the
// client wire DTO (disputely-types) and the merchant RPC DTO so the leaves live once.

/** Loose autofill key→value map; per-field type varies, so it's passed through untyped. */
export const autofillSuggestedFormDataSchema = z.record(
  z.string(),
  z.union([z.string(), z.boolean(), z.number()]).nullable(),
);

/** One autofill screenshot: storage URL + the page it was captured from. */
export const autofillScreenshotSchema = z.object({
  url: z.string(),
  sourceUrl: z.string().nullish(),
});

/** The five screenshot slots §8.1 returns. */
export const autofillScreenshotsSchema = z.object({
  homepage: autofillScreenshotSchema.nullish(),
  refundPolicy: autofillScreenshotSchema.nullish(),
  tos: autofillScreenshotSchema.nullish(),
  privacyPolicy: autofillScreenshotSchema.nullish(),
  checkout: autofillScreenshotSchema.nullish(),
});

/** Per-field source page URLs Disputely scraped each value from. */
export const autofillSourcesSchema = z.record(z.string(), z.string());
